const Nav = {
  overlay: {
    backdropFilter: 'blur(3px)',
  },
  content: {
    top: '42.5%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '90%',
    minWidth: '60%',
    backgroundColor: 'rgb(211,211,211)',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '1em',
    paddingRight: '1em',
    direction: 'rtl',
    overflowY: 'hidden',
  },
};
export default Nav;
